const FEATURE_HELP_URLS = {
  agent_bots: 'https://manysends.com/help-center/agent-bots',
  agents: 'https://manysends.com/help-center/agents',
  audit_logs: 'https://manysends.com/help-center/audit-logs',
  campaigns: 'https://manysends.com/help-center/campaigns',
  canned_responses: 'https://manysends.com/help-center/canned',
  channel_email: 'https://manysends.com/help-center/email',
  channel_facebook: 'https://manysends.com/help-center/fb',
  custom_attributes: 'https://manysends.com/help-center/custom-attributes',
  dashboard_apps: 'https://manysends.com/help-center/dashboard-apps',
  help_center: 'https://manysends.com/help-center',
  inboxes: 'https://manysends.com/help-center/inboxes',
  integrations: 'https://manysends.com/help-center/integrations',
  labels: 'https://manysends.com/help-center/labels',
  macros: 'https://manysends.com/help-center/macros',
  message_reply_to: 'https://manysends.com/help-center/reply-to',
  reports: 'https://manysends.com/help-center/reports',
  sla: 'https://manysends.com/help-center/sla',
  team_management: 'https://manysends.com/help-center/teams',
  webhook: 'https://manysends.com/help-center/webhooks',
  billing: 'https://manysends.com/pricing',
  saml: 'https://manysends.com/help-center/saml',
  captain_billing: 'https://manysends.com/help-center/captain_billing',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
